import { FieldValues, Path } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { SegmentedControlField } from '../SegmentedControlField';

type ScopePropsType<T extends FieldValues> = {
  fieldName: Path<T>;
};

export const Scope = <T extends FieldValues>({
  fieldName,
}: ScopePropsType<T>): React.ReactElement => {
  const { t } = useTranslation();

  return (
    <SegmentedControlField<T>
      fieldName={fieldName}
      label={t('REPORTS.MAILING_FORM.SCOPE')}
      options={[
        { value: 'SHOW', label: t('REPORTS.ENUMS.SCOPE.SHOW') },
        { value: 'TOUR', label: t('REPORTS.ENUMS.SCOPE.TOUR') },
      ]}
    />
  );
};
